import { Box, Modal, Text, toast } from "dash-ui";
import {
  GetCurrentBrokerDocument,
  useAttachDefaultStripePaymentMethodMutation,
} from "gql/generated.graphql";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { StripePaymentForm } from "../StripePaymentForm";

const AddPaymentMethodModal = ({
  isOpened,
  onClose,
}: {
  isOpened: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation(["forms", "common", "pages"]);
  const theme = useTheme();

  const closeModal = () => {
    onClose();
  };

  const formRef = useRef<HTMLFormElement>(null);

  const [attachDefaultPaymentMethod, { loading }] =
    useAttachDefaultStripePaymentMethodMutation({
      refetchQueries: [GetCurrentBrokerDocument],
      onCompleted: () => {
        toast.success("Payment method added!");
        toast.success("Payment method set as default!");
      },
      onError: (error) => {
        toast.error(`Error: ${error.message}`);
      },
    });

  function handleSubmit(paymentMethodId: string) {
    attachDefaultPaymentMethod({
      variables: {
        stripePaymentMethodId: paymentMethodId,
      },
    });
    closeModal();
  }

  const [invalidForm, setInvalidForm] = useState(true);

  return (
    <Modal
      minWidth={["unset", 586, 586, 586]}
      title={t("pages:profilePage.billing.addPaymentModalTitle") || ""}
      isOpen={isOpened}
      onRequestClose={closeModal}
      submitButton={{
        title: t("common:labels.add"),
        disabled: invalidForm,
        isLoading: loading,
        onClick: () => {
          if (formRef.current) {
            formRef.current.requestSubmit();
          }
        },
      }}
      cancelButton={{
        title: t("common:labels.cancel"),
        onClick: closeModal,
      }}>
      <Box mt={1} mb={3}>
        <Text color={theme.colors.n80}>
          {t("pages:profilePage.billing.addPaymentModalSubTitle")}
        </Text>
      </Box>
      <StripePaymentForm formRef={formRef} onSubmit={handleSubmit} setInvalidForm={setInvalidForm} />
    </Modal>
  );
};

export default AddPaymentMethodModal;
